// // import {alertDialog, Serenity.Decorators, EditorProps, EditorWidget, Fluent, getType, informationDialog, IReadOnly} from "@serenity-is/corelib";

// /**
//  * Options for configuring the SearchButtonEditor.
//  */
// namespace GeniuzPOS.Common {


// export interface SearchButtonEditorOptions {
//     /**
//      * The name of the ID column.
//      */
//     idColumnName?: string;

//     /**
//      * The name of the text column.
//      */
//     textColumnName?: string;

//     /**
//      * The type of the dialog class.
//      */
//     dialogClassType?: string;

//     /**
//      * Whether the clear button can be displayed.
//      */
//     canClear?: boolean;

//     /**
//      * The template for displaying the selected value.
//      */
//     displayTemplate?: string;

//     /**
//      * Whether the editor should render itself.
//      */
//     selfRender?: boolean;

//     /**
//      * Minimum number of characters required for search
//      */
//     minSearchLength?: number;
// }

// @Serenity.Decorators.registerEditor("Gc.SearchButtonEditor")
// /**
//  * Represents an editor with a search button that opens a dialog for selecting values.
//  *
//  * @template P - The type of the options for configuring the SearchButtonEditor.
//  */
// @Serenity.Decorators.registerEditor("Gc.SearchButtonEditor")
// export class SearchButtonEditor<P extends SearchButtonEditorOptions = SearchButtonEditorOptions>
//     extends EditorWidget<P>
//     implements IReadOnly
// {
//     private readonly _fieldName: string;
//     private _filterKeys: { [key: string]: any } = {};
//     private _dummyElement: HTMLInputElement;
//     private defaultDisplayTemplate = "({id})-{value}";
//     private _minSearchLength: number;

//     static override createDefaultElement() {
//         return Fluent('input').attr("type", "text").addClass("d-none").getNode()
//     }
//     declare readonly domNode: HTMLInputElement;



//     constructor(prop: EditorProps<P>) {
//         super(prop);

//         if (!this.props.dialogClassType) {
//             console.error("dialogClassType is required.");
//             return;
//         }

//         this._fieldName = this.domNode.getAttribute("name");
//         if (this.props.idColumnName && this.props.idColumnName !== this._fieldName) {
//             this._fieldName = this.props.idColumnName;
//         }

//         this._minSearchLength = this.props.minSearchLength ?? 0;

//         this.renderElement();
//     }

//     protected renderElement() {
//         // Input element with dynamic placeholder
//         this._dummyElement = Fluent('input').attr("type", "text")
//             .attr("placeholder", this._minSearchLength > 0 
//                 ? `Enter at least ${this._minSearchLength} characters, then search or press F2/Enter`
//                 : "Enter search value or press F2/Enter to search all")
//             .class("editor form-control search-button-editor")
//             .getNode() as HTMLInputElement;
//         this.domNode.parentElement.insertBefore(this._dummyElement, this.domNode);

//         const fieldName = this.domNode.getAttribute("name");

//         // Search button
//         const searchBtn = document.createElement("button");
//         searchBtn.setAttribute("type", "button");
//         searchBtn.classList.add("inplace-button", `search-${fieldName}-button`, "custom-search-btn", "btn");
//         searchBtn.style.padding = "0.375rem 0.8rem";
//         searchBtn.style.height = "calc(1.5em + 0.75rem + 2px)";
//         searchBtn.style.fontSize = "1.2em";
//         searchBtn.style.minWidth = "40px";
        
//         const searchIcon = document.createElement("i");
//         searchIcon.classList.add("fa", "fa-search", "fa-lg");
//         searchIcon.style.fontSize = "1.2em";
//         searchBtn.appendChild(searchIcon);
        
//         this.domNode.parentElement.insertBefore(searchBtn, this.domNode.nextSibling);

//         // Clear button
//         if (this.props.canClear ?? true) {
//             const clearBtn = document.createElement("button");
//             clearBtn.setAttribute("type", "button");
//             clearBtn.classList.add("inplace-button", `clear-${fieldName}-button`, "custom-clear-btn", "btn");
//             clearBtn.style.padding = "0.375rem 0.8rem";
//             clearBtn.style.height = "calc(1.5em + 0.75rem + 2px)";
//             clearBtn.style.fontSize = "1.2em";
//             clearBtn.style.minWidth = "40px";

//             const clearIcon = document.createElement("i");
//             clearIcon.classList.add("fa", "fa-times", "fa-lg");
//             clearIcon.style.fontSize = "1.2em";
//             clearBtn.appendChild(clearIcon);

//             this.domNode.parentElement.insertBefore(clearBtn, this.domNode.nextSibling);

//             clearBtn.onclick = (e) => {
                
//                 const changeEvent = new CustomEvent("dataSelected", {
//                     detail: { [this.props.idColumnName]: "" }
//                 });
//                 this.domNode.dispatchEvent(changeEvent);
//                 this.domNode.value = "";
//                 this._dummyElement.value = "";
//                 this._dummyElement.classList.remove("readonly");
//                 this._dummyElement.removeAttribute("readonly");
//                 this._dummyElement.focus();
//             }
//         }

//         // open dialog when press f2 key on the _dummyElement
//         this._dummyElement.addEventListener("keydown", (e) => {
//             if (e.key === "F2") {
//                 searchBtn.click();
//             }
//             if (e.key === "Enter") {
//                 searchBtn.click();
//             }
//         });

//         searchBtn.onclick = (e) => {
//             if (this._minSearchLength > 0) {
//                 const searchValue = this._dummyElement.value.trim();
//                 if (searchValue.length < this._minSearchLength && !this._dummyElement.hasAttribute("readonly")) {
//                     informationDialog(`Enter at least ${this._minSearchLength} characters, then search or press F2/Enter`);
//                     return;
//                 }
//             }

//             const DialogClass = getType(this.props.dialogClassType) as { new (...args: any[]): any };
//             if (!DialogClass) {
//                 console.error(`Dialog class ${this.props.dialogClassType} not found.`);
//                 return;
//             }

//             const dlg = new DialogClass({});
//             if (Object.keys(this._filterKeys).length > 0) {
//                 dlg["FilterKeys"] = this._filterKeys;
//             }

//             if (this._dummyElement.getAttribute("readonly") == null) {
//                 dlg["SearchValue"] = this._dummyElement.value.trim();
//             }
//             else {
//                 dlg["SearchValue"] = this.domNode.value.trim();
//             }

//             dlg.dialogOpen();

//             dlg.element[0].addEventListener('onDialogClose', (e: any) => {
//                 const data = e["detail"];
//                 if (data && Object.keys(data).length > 0) {
//                     this.domNode.value = data[this.props.idColumnName];

//                     const changeEvent = new CustomEvent("dataSelected", {detail: data});
//                     this.domNode.dispatchEvent(changeEvent);

//                     if (this.props.selfRender ?? true) {
//                         this.setDisplayText(data[this._fieldName], data[this.props.textColumnName]);
//                     }
//                 }
//             });
//         };
//     }

//     get_value(): any {
//         return this.domNode.value;
//     }

//     get value(): any {
//         return this.get_value();
//     }

//     set_value(value: any) {
//         this.domNode.value = value;
//         this.setDisplayText(value);
//     }

//     set value(value: any) {
//         this.set_value(value);
//     }

//     set filterKeys(filters: { [key: string]: any }) {
//         this._filterKeys = filters;
//     }

//     public setDisplayText(id: string, value?: any) {
//         this._dummyElement.value = this.formatTemplate(this.props.displayTemplate, id, value);
//         this._dummyElement.classList.add("readonly");
//         this._dummyElement.setAttribute("readonly", "readonly");
//     }

//     private formatTemplate(template: string, ...params: (string | number | null | undefined)[]): string {

//         // Filter out undefined or null parameters
//         const filteredParams = params.filter(param => param != null).map(String);

//         if (filteredParams.length === 0) {
//             return "";
//         }

//         // If only one parameter is provided, return it directly
//         if (filteredParams.length === 1) {
//             return filteredParams[0];
//         }

//         // Define a mapping of positional arguments to the template keys
//         const keys = ['id', 'value']; // Extend this array if you have more placeholders
//         const paramMap: { [key: string]: string } = {};

//         // Assign the parameters to their respective keys, converting each to a string
//         keys.forEach((key, index) => {
//             paramMap[key] = String(filteredParams[index] || '');
//         });

//         template = template || this.defaultDisplayTemplate;

//         // Replace the template placeholders with actual parameter values
//         return template.replace(/\{(\w+)}/g, (match, key) => paramMap[key] || '');
//     }

//     get_readOnly(): boolean {
//         return this.domNode.getAttribute('disabled') != null
//     }

//     set_readOnly(value: boolean): void {
//         if (this.get_readOnly() !== value) {
//             if (value) {
//                 this.domNode.setAttribute('disabled', 'disabled')
//             } else {
//                 this.domNode.removeAttribute('disabled')
//             }
//         }
//     }

//     public setMinSearchLength(length: number) {
//         this._minSearchLength = length;
//         this._dummyElement.setAttribute("placeholder", length > 0
//             ? `Enter at least ${length} characters, then search or press F2/Enter`
//             : "Enter search value or press F2/Enter to search all");
//     }
// }
// }
